/* eslint-disable max-len */
import React, { FC } from 'react';
import { Button, Prompt } from '../../ui';
import { Copy, TextArea } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from './Popup';

export interface DumpPopupArgs<T> {
    title?: string;
    copy?: string;
    dump?: string;
}

export const dumpPopup = <T extends unknown>(args: DumpPopupArgs<T>) => ({ ui: DumpPopup, args });

export const DumpPopup: FC<PopupProps<DumpPopupArgs<any>>> = ({ dismiss, args }) => {

    return <Prompt ignoreEnter onAction={dismiss}>
        <Popup w={36}>
            <Popup.Close onAction={dismiss} />
            <Popup.Title>{args.title || 'Your Data'}</Popup.Title>
            <Popup.Content>
                {args.copy && <Copy>{args.copy}</Copy>}
                <TextArea readOnly cols={20} rows={30} value={args.dump} />
            </Popup.Content>
            <Popup.Actions>
                <Button variant="common" onAction={() => dismiss}>
                    Close
                </Button>
            </Popup.Actions>
        </Popup>
    </Prompt>;
};
